import React from 'react';
import Icon from '@/components/ui/Icon';

export interface SortIndicatorProps {
  /** Current sort direction, or false if unsorted */
  direction: false | 'asc' | 'desc';
  /** Icon size in pixels */
  size?: number;
}

const SortIndicator = ({ direction, size = 14 }: SortIndicatorProps) => {
  if (!direction) {
    return (
      <span className="tw-inline-flex tw-flex-col tw-ml-1 tw-align-middle tw-text-gray-400 tw-leading-none">
        <Icon height={size} icon="ChevronUp" width={size} />
        <span style={{ marginTop: -2 }}>
          <Icon height={size} icon="ChevronDown" width={size} />
        </span>
      </span>
    );
  }

  return (
    <span className="tw-inline-flex tw-ml-1 tw-align-middle">
      {direction === 'asc' && <Icon height={size} icon="ChevronUp" width={size} />}
      {direction === 'desc' && <Icon height={size} icon="ChevronDown" width={size} />}
    </span>
  );
};

export default SortIndicator;
